import DigitalGiveawayButton from './DigitalGiveawayButton'
import digitalGiveawayButtonContainer from './digitalGiveawayButtonContainer'

export default digitalGiveawayButtonContainer(DigitalGiveawayButton)
